module.exports = __webpack_public_path__ + "img/Green-bull.18fe9531.svg";